export default (theme) => ({
  '@global': {
    '.H_l_right': {
      display: 'none !important',
    },
    '@keyframes pulsate': {
      '0%': {
        transform: 'scale(0.1, 0.1)',
        opacity: 0,
      },
      '50%': {
        opacity: 1,
      },
      '100%': {
        transform: 'scale(1.2, 1.2)',
        opacity: 0,
      },
    },
    '.mapboxgl-ctrl-bottom-left': {
      bottom: 16,
    },
    '.mapboxgl-ctrl-bottom-right': {
      width: 'fit-content',
      left: 0,
      bottom: 0,
    },
  },
  overlayMap: {
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      position: 'fixed',
      width: `calc(100% - ${theme.gofind.asideWidth}px)`,
      height: '100vh',
      left: theme.gofind.asideWidth,
      zIndex: 102,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      backdropFilter: 'blur(8px)',
      '& p': {
        textAlign: 'center',
        fontSize: 22,
        color: '#FFF',
        maxWidth: 333,
      },
    },
  },
  Map: {
    width: '100%',

    [theme.breakpoints.up('md')]: {
      '&.withSidebar': {
        position: 'absolute',
        width: `calc(100% - ${theme.gofind.asideWidth}px)`,
        left: theme.gofind.asideWidth,
      },
      marginTop: 0,
    },

    '& .gofind-map-user': {
      width: 25,
      height: 25,
      marginTop: -25,
      display: 'inline-block',

      zIndex: 100,
      userSelect: 'none',
    },

    '& .gofind-map-store': {
      userSelect: 'none',
      width: 28 * 1.2,
      height: 44.8 * 1.2,

      zIndex: 90,

      '& .map-title': {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        pointerEvents: 'none',
        position: 'absolute',
        left: '50%',
        top: -30,
        background: 'rgba(255,255,255)',
        padding: 8,
        fontSize: 13,
        zIndex: 5,
        whiteSpace: 'nowrap',
        transform: 'translate(-50%, -50%)',
        opacity: 0,
        transition: '.3s ease',
      },

      '& > img': {
        width: '100%',
        display: 'inline-block',
        position: 'relative',
        transition: '.3s ease',
        pointerEvents: 'none',
        zIndex: 3,
      },

      '&:hover': {
        zIndex: '250 !important',
        '& .store-shadow': {
          opacity: 1,
          transform: 'scale(1.5) translate(0, -10px)',
        },
        '& > img': {
          transform: 'scale(1.5)',
          zIndex: 4,
        },
      },

      '& .store-shadow': {
        bottom: 15,
        left: 5,
        width: 24,
        height: 19,
        display: 'block',
        position: 'absolute',
        boxShadow: '0 22px 13px rgba(0,0,0,0.77)',
        borderRadius: 10,
        opacity: 0.5,
        transform: 'scale(0.5)',
        transition: '.3s ease',
        zIndex: 1,
        userSelect: 'none',
        pointerEvents: 'none',
      },

      '& .store-pulse': {
        height: 14,
        width: 14,
        position: 'absolute',
        top: '50%',
        left: '50%',
        margin: '11px 0px 0px -7px',
        transform: 'rotateX(55deg)',

        '&:after': {
          content: '""',
          borderRadius: '50%',
          height: 50,
          width: 50,
          position: 'absolute',
          margin: '-11px 0 0 -17.5px',
          opacity: 0,

          animationIterationCount: 'infinite',

          boxShadow: '0 0 1px 2px #fe7a0c',
          animationDelay: '1.1s',
        },
      },
    },
  },
})
